import React, { useState, useEffect } from 'react';
import { useTenant } from '../contexts/TenantContext';
import { superAdminAPI } from '../services/garageApi';

const TenantSelector = ({ onTenantSwitch }) => {
  const [tenants, setTenants] = useState([]);
  const [loading, setLoading] = useState(true);
  const { isSuperAdmin } = useTenant();

  useEffect(() => {
    if (isSuperAdmin) {
      // Fetch available tenants
      const fetchTenants = async () => {
        try {
          setLoading(true);
          console.log('🔍 TenantSelector: Fetching tenants...');
          const response = await superAdminAPI.getAllTenants();
          console.log('🔍 TenantSelector: Full response:', response);
          console.log('🔍 TenantSelector: Response data:', response.data);
          console.log('🔍 TenantSelector: Response data type:', typeof response.data);
          console.log('🔍 TenantSelector: Response data keys:', Object.keys(response.data || {}));
          console.log('🔍 TenantSelector: Response data is array?', Array.isArray(response.data));
          console.log('🔍 TenantSelector: Response data length:', response.data?.length);
          
          // Handle different response structures
          let tenantsData = response.data;
          
          // Check if response has a nested data structure (Laravel pagination)
          if (response.data && response.data.data && Array.isArray(response.data.data)) {
            tenantsData = response.data.data; // This is the actual tenants array
            console.log('🔍 TenantSelector: Using nested data structure (Laravel pagination)');
          } else if (Array.isArray(response.data)) {
            tenantsData = response.data;
            console.log('🔍 TenantSelector: Using direct array structure');
          } else if (response.data && Array.isArray(response.data.tenants)) {
            tenantsData = response.data.tenants;
            console.log('🔍 TenantSelector: Using tenants property');
          } else {
            console.warn('⚠️ TenantSelector: Unexpected response structure:', response.data);
            tenantsData = [];
          }
          
          console.log('🔍 TenantSelector: Processed tenants data:', tenantsData);
          console.log('🔍 TenantSelector: Tenants count:', tenantsData.length);
          setTenants(tenantsData);
        } catch (error) {
          console.error('❌ TenantSelector: Failed to fetch tenants:', error);
          setTenants([]); // Set empty array on error
        } finally {
          setLoading(false);
        }
      };
      
      fetchTenants();
    }
  }, [isSuperAdmin]);

  if (!isSuperAdmin) {
    return null;
  }

  if (loading) {
    return (
      <div className="px-4 py-2 text-sm text-gray-500">
        Loading tenants...
      </div>
    );
  }

  // Safety check to ensure tenants is an array
  if (!Array.isArray(tenants)) {
    console.error('❌ TenantSelector: tenants is not an array:', tenants);
    return (
      <div className="px-4 py-2 text-sm text-red-600 bg-red-100 rounded-lg border border-red-300">
        Error: Invalid tenants data
      </div>
    );
  }

  if (tenants.length === 0) {
    return (
      <div className="px-4 py-2 text-sm text-gray-500 bg-gray-100 rounded-lg border border-gray-300">
        No tenants available
      </div>
    );
  }

  return (
    <select 
      onChange={(e) => onTenantSwitch(e.target.value)}
      className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
      defaultValue=""
    >
      <option value="">Select a tenant to view</option>
      {tenants.map(tenant => (
        <option key={tenant.id} value={tenant.id}>
          {tenant.name}
        </option>
      ))}
    </select>
  );
};

export default TenantSelector;
